import './image-text.scss';
import './image-text.html.twig';

export default function () {
  const currentWidth = window.matchMedia('(min-width: 1024px)');

  function animate(image) {
    const container = image.parentElement;
    const scrolled = container.getBoundingClientRect().top;
    image.style.transform = `translateY(${-scrolled * 0.15}px)`;
  }

  function parallax(image) {
    window.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        animate(image);
      });
    });
  }

  if ('IntersectionObserver' in window) {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          const image = entry.target.querySelector('.image-text__image');
          if (entry.isIntersecting && currentWidth.matches) {
            parallax(image);
            if (!entry.target.classList.contains('animate-children')) {
              entry.target.classList.add('animate-children');
            }
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '-20px' }
    );

    const imageText = [...document.querySelectorAll('.image-text')];
    imageText.forEach((container) => {
      observer.observe(container);
    });
  }
}
